import type { WhitelabelVariantDefinition } from '../../types';

export const engacontWhitelabel = {
  id: 'engacont',
  colors: {
    primary: {
      900: '#0D0E0D',
      800: '#161817',
      700: '#202221',
      500: '#5A5B5B',
      300: '#949594',
      100: '#E9E9E9',
      contrastText: '#FFFFFF',
    },
  },
} as const;

export const engacontDefaultTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: engacontWhitelabel.colors.primary[900],
      dark: engacontWhitelabel.colors.primary[800],
      main: engacontWhitelabel.colors.primary[700],
      light: engacontWhitelabel.colors.primary[500],
      lighter: engacontWhitelabel.colors.primary[300],
      muted: engacontWhitelabel.colors.primary[100],
      contrastText: engacontWhitelabel.colors.primary.contrastText,
    },
  },
  typography: { fontFamily: 'Montserrat' },
};
